import { DatePicker, Input, Pagination, Select, Table, Modal } from "antd";
import dayjs from "dayjs";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from "react-router-dom";
import { getChipSummary, settleChipAsync } from "../../redux/slice/chipSummary/chipSummarySlice";
import { getUserBalanceAsync } from "../../redux/slice/user/userSlice";

function ChipSummary() {
    const navigate = useNavigate()
    const { isAuthenticated } = useSelector((state) => state.authSlice);
    const profileData = useSelector((state) => state.authSlice.profileData);
    const dispatch = useDispatch();
    const { data, loading } = useSelector((state) => state.chipSummary);
    const [openSettleModal, setOpenSettleModal] = useState(false)
    const [selectedAccount, setSelectedAccount] = useState(null)
    const [settleAmount, setSettleAmount] = useState(0)
    const [remark, setRemark] = useState("")
    const [plusAccount, setPlusAccount] = useState([])
    const [minusAccount, setMinusAccount] = useState()
    useEffect(() => {
        if (isAuthenticated) {
            dispatch(getChipSummary());
        }
    }, [dispatch, isAuthenticated]);

    useEffect(() => {
        if (data?.reports?.length > 0) {
            const plus = data?.reports?.filter(e => e?.p_l > 0)
            setPlusAccount(plus)
            const minus = data?.reports?.filter(e => e?.p_l < 0)
            setMinusAccount(minus)
        }
    }, [data])


    const handleSettle = (account) => {
        console.log('account:', account)
        setSelectedAccount(account)
        setOpenSettleModal(true)
    }

    const handleSubmitSettle = () => {
        const data = {
            user_id: selectedAccount?.user_id,
            master_id: profileData?._id,
            type: selectedAccount?.p_l > 0 ? 'Debit' : 'Credit',
            amount: settleAmount,
            remarks: remark
        }

        dispatch(settleChipAsync(data))
        dispatch(getUserBalanceAsync())
        dispatch(getChipSummary())
        setSettleAmount(0)
        setRemark("")
        setSelectedAccount(null)
        setOpenSettleModal(false)
    }

    return (
        <div className='relative min-w-full'>
            <div className='grid grid-cols-12 relative p-[15px] gap-[20px]' >
                <div className='col-span-12  '>
                    <div className=' w-full'>
                        <div className='font-bold text-[0.938rem] leading-[23px] bg-[linear-gradient(#022c43,_#18b0c8)] px-[10px] py-[5px] text-[#ffffff] rounded-tl-[calc(.25rem-1px)] rounded-br-[0] rounded-tr-[calc(.25rem-1px)] rounded-bl-[0]'>
                            Chip Summary
                        </div>
                    </div>
                </div>
                <Modal title={`User Name - ${selectedAccount?.name}`} className='rollingcommission-model relative top-1 lg:top-7 lg:!w-[34vw]'
                    onCancel={() => {
                        setOpenSettleModal(false)
                    }}
                    open={openSettleModal}
                    footer={
                        (
                            <button type="button" data-bs-dismiss="modal" aria-label="Close" className={`m-[20px] text-[#fff]  bg-[#4dbd74] border-[#4dbd74] font-bold !px-[10px] !py-[5px] !text-[.875rem] rounded-[.375rem] `}
                                onClick={() => handleSubmitSettle()}
                            >Submit</button>
                        )
                    }
                >
                    <div className='grid grid-cols-12 px-[1rem] py-[.75rem] '>
                        <div className='col-span-12  py-[7px]'>
                            <div className="w-full">
                                Chips
                            </div>
                            <div className="w-full">
                                <Input
                                    name="amount"
                                    placeholder=""
                                    value={settleAmount}
                                    type="number"
                                    class="block w-full px-[.75rem] py-[.375rem] text-[.875rem] leading-normal text-[#5c6873] bg-[#fff] bg-clip-padding border-[1px] border-[solid] border-[#e4e7ea] rounded-[.25rem] [transition:border-color_.15s_ease-in-out,_box-shadow_.15s_ease-in-out] font-normal"
                                    onChange={(e) => setSettleAmount(e.target.value)}
                                />
                            </div>
                        </div>
                        <div className='col-span-12  py-[7px]'>
                            <div className="w-full">
                                Remark
                            </div>
                            <div className="w-full">
                                <Input
                                    name="remark"
                                    placeholder="Remark.."
                                    value={remark}
                                    type="text"
                                    class="block w-full px-[.75rem] py-[.375rem] text-[.875rem] leading-normal text-[#5c6873] bg-[#fff] bg-clip-padding border-[1px] border-[solid] border-[#e4e7ea] rounded-[.25rem] [transition:border-color_.15s_ease-in-out,_box-shadow_.15s_ease-in-out] font-normal"
                                    onChange={(e) => setRemark(e.target.value)}
                                />
                            </div>
                        </div>
                    </div>
                </Modal >
                <div className="col-span-12 lg:col-span-6 overflow-x-auto">
                    <table className="w-full whitespace-nowrap !mb-6 text-[#212529]">
                        <thead className=''>
                            <tr className="!bg-[#028dad] !text-[#ffffff]">
                                <th colSpan={4} className='p-[4px] align-bottom border-b-[#b9b9b9]  '>PLUS ACCOUNT (Dena Hai)</th>
                            </tr>
                            <tr className="">
                                <th className='p-[4px]  border-[#b9b9b9] border-[1px] align-bottom  '>Name</th>
                                <th className='p-[4px] border-[#b9b9b9] border-[1px] align-bottom '>Account</th>
                                <th className='p-[4px] border-[#b9b9b9] border-[1px] align-bottom  '>Chips</th>
                                <th className='p-[4px] border-[#b9b9b9] border-[1px] align-bottom  '></th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                plusAccount?.map((e, i) => (
                                    <tr>
                                        <td className='p-[4px] border-[#b9b9b9] border-[1px] align-bottom  '>{e?.name}</td>
                                        <td className='p-[4px] border-[#b9b9b9] border-[1px] align-bottom  '>{e?.user_name}</td>
                                        <td className='p-[4px] text-[#508d0e] border-[#b9b9b9] border-[1px] align-bottom  '>{e?.p_l ? Number(e?.p_l).toFixed(2) : '-'}</td>
                                        <td className='p-[4px] border-[#b9b9b9] border-[1px] align-bottom  '>
                                            <div className="flex gap-[5px]">
                                                <button type="button" className='rounded-[3px] mb-px text-[#fff] bg-[#e2a521] hover:bg-[#286090] border-[#e2a521] hover:border-[#286090] px-[5px] py-px  leading-normal text-center whitespace-nowrap cursor-pointer italic'
                                                    onClick={() => navigate(`/accountstatement`, { state: { user_id: e?.user_id } })}
                                                >Ledger</button>
                                                <button type="button" className='rounded-[3px] mb-px text-[#fff] bg-[linear-gradient(#61cce6,_#29a3c2)] hover:!bg-[linear-gradient(#29a3c2,_#61cce6)] border-[#028dad] hover:border-[#286090] px-[5px] py-px  leading-normal text-center whitespace-nowrap cursor-pointer italic'
                                                    onClick={() => handleSettle(e)}
                                                >Settlement</button>
                                            </div>
                                        </td>
                                    </tr>
                                ))
                            }
                        </tbody>
                        <tfoot>
                            <tr className="border-[#b9b9b9] border-[1px]">
                                <td colSpan={2} className='p-[4px] align-bottom '>Total</td>
                                <td colSpan={2} className={`p-[4px] align-bottom  ${plusAccount?.reduce((total, item) => total + (item.p_l || 0), 0) >= 0
                                    ? 'text-[#508d0e]'
                                    : 'text-[#d50000]'
                                    }`}>
                                    {plusAccount?.reduce((total, item) => total + (item.p_l || 0), 0).toFixed(2)}
                                </td>
                            </tr>
                        </tfoot>
                    </table>
                </div>

                <div className="col-span-12 lg:col-span-6 overflow-x-auto">
                    <table className="w-full whitespace-nowrap  text-[#212529]">
                        <thead className=''>
                            <tr className="!bg-[#028dad] !text-[#ffffff]">
                                <th colSpan={4} className='p-[4px] align-bottom border-b-[#b9b9b9]  '>MINUS ACCOUNT (Lena Hai)</th>
                            </tr>
                            <tr className="">
                                <th className='p-[4px]  border-[#b9b9b9] border-[1px] align-bottom  '>Name</th>
                                <th className='p-[4px] border-[#b9b9b9] border-[1px] align-bottom '>Account</th>
                                <th className='p-[4px] border-[#b9b9b9] border-[1px] align-bottom  '>Chips</th>
                                <th className='p-[4px] border-[#b9b9b9] border-[1px] align-bottom  '></th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                minusAccount?.map((e, i) => (
                                    <tr>
                                        <td className='p-[4px] border-[#b9b9b9] border-[1px] align-bottom  '>{e?.name}</td>
                                        <td className='p-[4px] text-[#d9534f] border-[#b9b9b9] border-[1px] align-bottom  '>{e?.user_name}</td>
                                        <td className='p-[4px] text-[#d9534f] border-[#b9b9b9] border-[1px] align-bottom  '>{e?.p_l ? Number(e?.p_l).toFixed(2) : '-'}</td>
                                        <td className='p-[4px] border-[#b9b9b9] border-[1px] align-bottom  '>
                                            <div className="flex gap-[5px]">
                                                <button type="button" className='rounded-[3px] mb-px text-[#fff] bg-[#e2a521] hover:bg-[#286090] border-[#e2a521] hover:border-[#286090] px-[5px] py-px  leading-normal text-center whitespace-nowrap cursor-pointer italic'
                                                    onClick={() => navigate(`/accountstatement`, { state: { user_id: e?.user_id } })}
                                                >Ledger</button>
                                                <button type="button" className='rounded-[3px] mb-px text-[#fff] bg-[linear-gradient(#61cce6,_#29a3c2)] hover:!bg-[linear-gradient(#29a3c2,_#61cce6)] border-[#028dad] hover:border-[#286090] px-[5px] py-px  leading-normal text-center whitespace-nowrap cursor-pointer italic'
                                                    onClick={() => handleSettle(e)}
                                                >Settlement</button>
                                            </div>
                                        </td>
                                    </tr>
                                ))
                            }
                        </tbody>
                        <tfoot>
                            <tr className="border-[#b9b9b9] border-[1px]">
                                <td colSpan={2} className='p-[4px] align-bottom '>Total</td>
                                <td colSpan={2} className={`p-[4px] align-bottom  ${minusAccount?.reduce((total, item) => total + (item.p_l || 0), 0) >= 0
                                    ? 'text-[#508d0e]'
                                    : 'text-[#d50000]'
                                    }`}>
                                    {minusAccount?.reduce((total, item) => total + (item.p_l || 0), 0).toFixed(2)}
                                </td>
                            </tr>
                        </tfoot>

                    </table>
                </div>
            </div>
        </div >
    )
}


export default ChipSummary;
